import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  Menu,
  MenuItem,
  Stack,
  SxProps,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';

import { getAuthState, signOut } from '../../../store/AuthSlice';
import { useAppSelector } from '../../../hooks';

const profileMenuItemStyles: SxProps = {
  borderRadius: '10px',
};

const HeaderUserProfileOptionsViewer: React.FC = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only('xs'));

  // Store
  const authState = useAppSelector(getAuthState);

  // State
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const authUser = authState.user;
  const isMenuOpen = Boolean(anchorEl);

  let userAvatar = '';
  let userAvatarFirstLetter = '';
  let userName = '';

  if (authUser) {
    if (authUser.avatar) {
      userAvatar = authUser.avatar;
    }

    if (authUser.firstname) {
      userName = authUser.firstname;
      userAvatarFirstLetter = authUser.firstname.charAt(0);

      if (authUser.lastname) {
        userName += ` ${authUser.lastname}`;
      }
    }
  }

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const signOutUser = () => {
    dispatch(signOut());
    closeMenu();
  };

  return (
    <>
      <Card elevation={0}>
        <CardActionArea
          id="profile-menu-button"
          aria-controls={isMenuOpen ? 'profile-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? 'true' : undefined}
          onClick={openMenu}
        >
          <CardContent sx={{ p: '3px' }}>
            <Stack direction="row" alignItems="center" gap={1}>
              {userAvatar ? (
                <Avatar
                  src={userAvatar}
                  sx={{ width: '35px', height: '35px' }}
                />
              ) : (
                <Avatar sx={{ width: '35px', height: '35px' }}>
                  {userAvatarFirstLetter}
                </Avatar>
              )}
              {!isXsScreen ? (
                <Stack>
                  <Typography
                    variant="subtitle2"
                    fontSize="14px"
                    fontWeight={600}
                    maxWidth="125px"
                    className="ellipsis-text"
                  >
                    {userName}
                  </Typography>
                </Stack>
              ) : null}
              {!isXsScreen ? (
                <>
                  {isMenuOpen ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </>
              ) : null}
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
      {/* MODALS */}
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={closeMenu}
        MenuListProps={{
          'aria-labelledby': 'profile-menu-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        PaperProps={{
          sx: { minWidth: '245px', p: '15px', borderRadius: '20px' },
        }}
      >
        <MenuItem
          onClick={signOutUser}
          sx={{
            ...profileMenuItemStyles,
            backgroundColor: 'error.light',
            color: 'error.main',
            '&:hover': {
              backgroundColor: 'error.light',
              color: 'error.main',
            },
          }}
        >
          Sign out
        </MenuItem>
      </Menu>
    </>
  );
};

export default HeaderUserProfileOptionsViewer;
